(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("StreamrNetwork", [], factory);
	else if(typeof exports === 'object')
		exports["StreamrNetwork"] = factory();
	else
		root["StreamrNetwork"] = factory();
})(self, () => {
return 